import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ApproveModalComponent } from '../modals/approve-modal/approve-modal.component';
import { DeclineModalComponent } from '../modals/decline-modal/decline-modal.component';

@Component({
  standalone: false,
  selector: 'app-work-entry-permit-details',
  templateUrl: './work-entry-permit-details.component.html',
  styleUrls: ['./work-entry-permit-details.component.scss'],
})
export class WorkEntryPermitDetailsComponent implements OnInit {
  activeIds: string[] = [];
  workers: any[] = [];
  viewOnly: boolean = true;
  status: string = 'declined';
  safetyDocuments: boolean = false;

  myForm = new FormGroup({
    markCriticalSwitch: new FormControl(),
  });

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal
  ) {
    this.activeIds = [
      'ngb-panel-0',
      'ngb-panel-1',
      'ngb-panel-2',
      'ngb-panel-3',
      'ngb-panel-4',
      'ngb-panel-5',
      'ngb-panel-6',
      'ngb-panel-7',
      'ngb-panel-8',
      'ngb-panel-9',
      'ngb-panel-10',
    ];

    this.myForm = this.formBuilder.group({
      markCriticalSwitch: ['', [Validators.required]],
    });

    this.workers = [
      {
        workerId: 1,
        name: 'Abhiram Kale',
        phoneNumber: '987456321',
        entryTime: '1:00 PM',
        exitTime: '5:00 PM',
      },
      {
        workerId: 2,
        name: 'Dhananjay Samra',
        phoneNumber: '987456321',
        entryTime: '1:00 PM',
        exitTime: '5:00 PM',
      },
      {
        workerId: 3,
        name: 'Suman Uppal',
        phoneNumber: '987456321',
        entryTime: '1:00 PM',
        exitTime: '5:00 PM',
      },
      {
        workerId: 4,
        name: 'Rakesh Reddy',
        phoneNumber: '987456321',
        entryTime: '1:00 PM',
        exitTime: '5:00 PM',
      },
    ];
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.viewOnly = JSON.parse(params['viewOnly']);
      console.log('viewOnly:', this.viewOnly);
    });
  }

  goToEditPage(): void {
    this.router.navigate(['/create-work-entry-permit']);
  }

  goToAnotherSMEPage(): void {
    this.router.navigate(['/sme-groups']);
  }

  onSubmit(): void {
    console.log(this.myForm.value);

    if (this.myForm.valid) {
    } else {
      this.myForm.markAllAsTouched();
    }
    this.openSuccessModal(30356894);
  }

  openSuccessModal(requestId: number): void {
    const modalOptions: NgbModalOptions = {
      size: 'lg',
    };

    const modalRef = this.modalService.open(
      ApproveModalComponent,
      modalOptions
    );
    // You can pass data to the modal using the `componentInstance` property
    modalRef.componentInstance.requestId = requestId;
    modalRef.hidden.subscribe(() => {
      this.router.navigate(['/list-ta-admin-requests']);
    });
  }

  openRemoveModal(plantId: string): void {
    const modalOptions: NgbModalOptions = {
      size: 'lg',
    };

    const modalRef = this.modalService.open(
      DeclineModalComponent,
      modalOptions
    );
    // You can pass data to the modal using the `componentInstance` property
    modalRef.componentInstance.id = plantId;
    modalRef.hidden.subscribe(() => {
      this.router.navigate(['/list-cla-admin-requests']);
    });
    console.log(plantId);
  }
}
